import api from '@/helpers/api'

const API_READ=`/api/register-option/`
const API_CORP=`/api/corporate/`
const API_UPDATE=`${API_CORP}update-register-option/`
const API_CREATE=API_READ
const API_DELETE=API_READ

export default {
  namespaced:true,
  state: {
    status: '',
    merchants:[],
    currUser: {},
    errMessage: '',
    meta:{
        limit:10,
        page:1,
        total:1
    },
    filter: {},
    search:{}
  },
  mutations: {
    request(state){
        state.status = 'loading'
    },
    success(state){
        state.status = 'success'
    },
    error(state){
        state.status = 'error'
    },
    read(state, {merchants}){
        state.merchants = [...merchants]
    },
    read_single_success(state, {merchants}){
        state.merchants = merchants
    },
    switch_page(state, {meta}){
        state.meta = {...meta}
    },
    add_filter(state, {filter}) {
        state.filter = {...filter};
    },
    clear_filter(state) {
        state.filter = {};
    },
    set_search(state, {search}){
        state.search = {...search};
    },
    clear_search(state){
        state.search = {};
    },
  },
  actions: {
    read({commit, state}){

        commit('request')

        const {meta} = state
        const {filter} = state
        const {search} = state

        return new Promise((resolve, reject) => {
            api.request('get', API_READ, {meta, filter, search})
            .then((result) => {
                commit('read',{merchants:result.data.data})
                commit('switch_page', {meta: {...result.data.meta}})
                commit('success')
                // commit('clear_filter');
                return resolve(result)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
    read_single({commit},id){

        commit('request');
        return new Promise((resolve, reject) => {
            api.request('get', `${API_READ}corporate/${id}`)
            .then((result) => {
                commit('success')
                return resolve(result);
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
    read_register_option({commit},id){

        commit('request');
        return new Promise((resolve, reject) => {
            api.request('get', `${API_READ}${id}`)
            .then((result) => {
                commit('success')
                return resolve(result);
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err);
            });
        });
    },
    delete({commit},id){

        commit('request');

        return new Promise((resolve, reject) => {
            api.request('delete', `${API_DELETE}${id}`)
            .then((response) => {
                commit('success')
                return resolve(response.data)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err.response.data)
            });
        });

    },
    update_register_option({commit},{data}){

        commit('request');
        
        return new Promise((resolve, reject) => {
            api.request('put', `${API_UPDATE}${data.id}`, {}, data)
            .then((request) => {
                commit('success');
                return resolve(request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });


    },
    create({commit},{data}){
        
        commit('request');

        return new Promise((resolve, reject) => {
            api.request('post', `${API_CREATE}`, {}, data)
            .then((request) => {
                commit('success');
                return resolve(request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)    
            });
        });


    }
  },
  getters : {
    merchants: ()=>state => state.merchants,
  }
}
